import { Injectable } from '@angular/core';
import { FirebaseMessaging, GetTokenResult } from '@capacitor-firebase/messaging';
import { PermissionStatus } from "@capacitor-firebase/messaging/dist/esm/definitions";
import { Capacitor } from '@capacitor/core';
import {SharedDataService} from "../shared-data/shared-data.service";
import {SendMessageToUserResponse, SendMessageToUserServiceRequest} from "../../../../server/services/firebase/sendMessageToUser.contract";
import {User} from "../../../../server/entities/user.entity";

@Injectable({
  providedIn: 'root'
})
export class FirebaseMessagingService {
  constructor(
    private sharedDataService: SharedDataService
  ) {
  }

  async updateTokenOfUser() {
    // Skip Firebase messaging on web platform
    if (!Capacitor.isNativePlatform()) {
      console.log('Skipping Firebase messaging setup on web platform');
      return;
    }

    // 1. get current user
    const user = await this.sharedDataService.getUser();
    if (!user) {
      return;
    }

    // 2. check permission
    let permission = await this.checkPermission();
    if (permission !== 'granted') {
      permission = await this.requestPermission();
      if (permission !== 'granted') {
        console.warn('Permission not granted for notifications');
        return;
      }
    }

    // 3. get token
    const token = await this.getToken();

    // 4. update user with token
    await this.sharedDataService.updateUserFcmToken(token);
  }

  async checkPermission(): Promise<string> {
    if (!Capacitor.isNativePlatform()) {
      return 'denied';
    }
    const result: PermissionStatus = await FirebaseMessaging.checkPermissions();
    return result.receive;
  }

  async requestPermission(): Promise<string> {
    if (!Capacitor.isNativePlatform()) {
      return 'denied';
    }
    const result: PermissionStatus = await FirebaseMessaging.requestPermissions();
    return result.receive;
  }

  async getToken(): Promise<string> {
    if (!Capacitor.isNativePlatform()) {
      return '';
    }
    const result: GetTokenResult = await FirebaseMessaging.getToken();
    return result.token;
  }

  async sendTestNotificationToUser( user: User): Promise<SendMessageToUserResponse> {
    const response = await new SendMessageToUserServiceRequest({
      userId: user.id,
      message: {
        title: 'Test erfolgreich',
        body: 'Wenn du diese Nachricht siehst, hat alles geklappt! 🎉',
      }
    }).execute();
    return response;
  }
}
